import React from "react";
import { NavItem } from "reactstrap";
import NnSongMenuLink from "./NnSongMenuLink";
import Menu from 'react-burger-menu/lib/menus/slide';

const NnSongMenu = ({isOpen, onChange, onClose, onKeyDown, skin, songs, timing, letters}) => (
  <Menu id="song-menu"
    burgerButtonClassName="no-menu-button"
    crossButtonClassName="menu-close-button"
    menuClassName={'menu'}
    itemListClassName={"menu-item-list"}
    itemClassName={"menu-item"}
    customOnKeyDown={onKeyDown}
    isOpen={isOpen}
    onStateChange={onChange}
    right
    width={'60%'}
  >
    <ul>
      {// iterate through all songs, creating a menu item for each
        Object.keys(songs).map((songId, i) => {
          return (
            <NavItem key={i} onClick={onClose}>
              <NnSongMenuLink skin={skin} songId={songId} timing={timing} letters={letters}>
                {songs[songId].title}
              </NnSongMenuLink>
            </NavItem>
          )
        })
      }
    </ul>
  </Menu>
)
export default NnSongMenu;
